import { Component } from 'react';
import ReactGA from 'react-ga4';
import { connect } from 'react-redux';
import withRouter from './hoc/withRouter';
import { getMyProfile } from './actions/user';
import {check as loggedIn} from './utils/tokenUtils';

if (localStorage.getItem('RecommendedCookies') === '1') {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_GA4);
  console.log('Google analytics is initialized!');
}
const withTracker = (WrappedComponent) => {
  const sendGA4PageView = (page, profile) => {
    const eventParameters = {
      hitType: 'pageview',
      page,
      profile_id: profile.id,
      user_group_id: profile.attributes['user-group-id'],
      psuedo_login: profile.attributes['psuedo-login'] || false,
      wse_bands: profile.attributes['wse-bands'],
      abm_codes: profile.attributes['abm-codes']
    };
    ReactGA.send(eventParameters);
  };
  const trackPage = async (page, profile, currentOutlet) => {
    setTimeout(() => {
      sendGA4PageView(page, profile, currentOutlet);
    }, 1000);
  };
  const HOC = class extends Component {
    getMyProfileThenTrackPage = (page) => {
      this.props.dispatch(getMyProfile()).then(() => {
        trackPage(page, this.props.profile, this.props.currentOutlet);
      }).catch((error) => {
        console.log(error);
      });
    }

    componentDidMount() {
      const { profile } = this.props;

      if (loggedIn() && !profile) {
        this.getMyProfileThenTrackPage(this.props.location.pathname);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  const mapStateToProps = state => ({
    profile: state.currentUser.profile
  });

  // withRouter shim injects `location` (react-router v6 removed the Route-component
  // pattern that previously supplied it).
  return withRouter(connect(mapStateToProps)(HOC));
};

export default withTracker;
